module.exports = __webpack_public_path__ + "static/media/avrupa_birligi_baskanligi_logo_tr.a94218ce.png";